module.exports = __webpack_public_path__ + "images/logout-illus-93ba5c88.svg";